import React from "react"

export const AngleDownIcon = () => {
  return (
    <svg
      width="7"
      height="4"
      viewBox="0 0 7 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.55664 3.40039C3.66406 3.50781 3.81445 3.50781 3.92188 3.40039L6.41406 0.886719C6.52148 0.779297 6.52148 0.607422 6.41406 0.521484L6.26367 0.371094C6.15625 0.263672 6.00586 0.263672 5.89844 0.371094L3.75 2.5625L1.58008 0.349609C1.47266 0.263672 1.32227 0.263672 1.21484 0.349609L1.06445 0.521484C0.957031 0.607422 0.957031 0.779297 1.06445 0.886719L3.55664 3.40039Z" />
    </svg>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Icons/AngleDownIcon.js